module.exports = __webpack_public_path__ + "static/media/logo3.69b29210.png";